import { Card } from "@volca/ui/components/ui/card";
import type {
  ReportBlock as Block,
  ReportControl,
  ReportControlValues,
  ReportDataset,
} from "@/profitability/types";
import { ReportBlock } from "./report-block";

/**
 * The narrowest a supporting figure may be. Below this its label, a phrase like
 * "Material & equipment PO costs", stops fitting on two lines.
 */
const MIN_FIGURE_PX = 190;

/**
 * The second tier of figures: smaller, together in one frame, divided by
 * hairlines. A page can carry three headline numbers and still say what the
 * supporting ones are without eight tiles competing for the same attention.
 */
export const SupportingFigures = ({
  businessId,
  runId,
  blocks,
  datasets,
  controls,
  values,
  lens,
}: {
  businessId: string;
  runId: string;
  blocks: Block[];
  datasets: ReportDataset[];
  controls: ReportControl[];
  values: ReportControlValues;
  lens?: { start_date: string; end_date: string } | null;
}) => (
  <Card className="flex flex-row flex-wrap items-stretch gap-0 overflow-hidden py-0 sm:col-span-2 lg:col-span-12">
    {blocks.map((block) => (
      <div
        key={block.id}
        style={{ flexBasis: `${MIN_FIGURE_PX}px` }}
        className="-mt-px -ml-px flex min-w-0 flex-1 border-t border-l"
      >
        <ReportBlock
          variant="inline"
          businessId={businessId}
          runId={runId}
          block={block}
          dataset={datasets.find((dataset) => dataset.id === block.dataset)!}
          controls={controls}
          values={values}
          lens={lens}
          placement={{ span: "", narrow: false }}
        />
      </div>
    ))}
  </Card>
);
